<template>
    <v-sheet v-if="!(mode == 'view' && !resume?.hashTags?.length)">
        <div class="d-flex align-center" style="position: relative">
            <h5 class="page-text--lg mb-8 mb-lg-16 line-height-15">
                해시태그
                <span v-if="mode == 'form'" class="page-text--sm grey-6--text pl-8 font-weight-regular">해시태그 기능은 기업에서 지원자 검색 시 활용 할수있으니 본인을 어필하시기 위한 해시태그를 꼭 체크해주세요.</span>
            </h5>
        </div>

        <v-sheet>
            <v-divider class="primary border-2" />
            <div class="pa-10 px-md-20 py-md-16">
                <template v-if="mode == 'form'">
                    <v-autocomplete v-model="resume.hashTags" :items="hashTags" :menuProps="{ attach: `.hash-tags-${className}` }" :class="`hash-tags-${className}`" multiple small-chips v-bind="attrs_input" @input="emit">
                        <template #selection="{ item }">
                            <v-chip outlined small label color="grey-d" class="grey-9--text ma-2 ma-lg-4">{{ item }}</v-chip>
                        </template>
                    </v-autocomplete>
                </template>
                <template v-else>
                    <v-chip-group v-if="resume?.hashTags?.length">
                        <v-chip v-for="hashTag in resume?.hashTags" :key="hashTag" outlined label disabled color="grey-d" class="grey-9--text">
                            {{ hashTag }}
                        </v-chip>
                    </v-chip-group>
                </template>
            </div>

            <v-divider />
        </v-sheet>
    </v-sheet>
</template>

<script>
import { attrs_input, initResume } from "@/assets/variables";

export default {
    props: {
        mode: { type: String, default: "form" },
        value: { type: Object, default: () => ({}) }, // resume
        hashTags: { type: Array, default: () => [] },
    },
    data: () => ({
        resume: initResume(),

        attrs_input,
        className: Math.random().toString().slice(2),
    }),
    mounted() {
        this.sync();
    },
    watch: {
        value() {
            this.sync();
        },
    },
    methods: {
        sync() {
            this.resume = { ...initResume(), ...this.value };
        },
        emit() {
            let { hashTags } = this.resume;
            this.$emit("input", { ...this.value, hashTags });
        },
    },
};
</script>

<style lang="scss" scoped>
::v-deep {
    .v-select--chips {
        .v-input__slot,
        .v-select__selections {
            height: auto;
            min-height: 40px !important;
        }
    }
}
@media (min-width: 576px) {
}
@media (min-width: 768px) {
}
@media (min-width: 1024px) {
    ::v-deep {
        .v-select--chips {
            .v-input__slot,
            .v-select__selections {
                min-height: 48px !important;
            }
        }
    }
}
@media (min-width: 1200px) {
}
</style>
